import React, { useState } from 'react';
import { Row, Col, ButtonGroup, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux'
import { ModalComponent } from '..';
import { Device } from '../../models';
import { forgetHost, forgetPrinter, forgetEft } from '../../redux';

import './ForgetDeviceButton.css';

const ForgetDeviceButton = ({ device }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const [confirmIsVisible, showConfirm] = useState(false);

    const {
        isLoadingOne, isForgetting,
        successfullyForgot, failedToForget
    } = useSelector(state => state.hosts);

    const forget = () => {
        showConfirm(false);
        switch (device.type) {
            case Device.TYPE_HOST:
                return dispatch(forgetHost(device));
            case Device.TYPE_PRINTER:
                return dispatch(forgetPrinter(device));
            case Device.TYPE_EFT:
                return dispatch(forgetEft(device));
        }
    }

    if (!device)
        return null;

    return (
        <>
            {confirmIsVisible && (
                <ModalComponent title={t(`devices.are_you_sure_to_forget_this_${device.type}`)}>
                    <Row>
                        <Col>
                            <ButtonGroup className="btn-block">
                                <Button color="warning" onClick={() => showConfirm(false) }>
                                    <i className={`fa fa-${isLoadingOne || isForgetting ? 'spinner fa-spin' : 'times'}`} />&nbsp;
                                    {t('common.cancel')}
                                </Button>
                                <Button color="primary" onClick={ forget }>
                                    <i className={`fa fa-${isLoadingOne || isForgetting ? 'spinner fa-spin' : 'trash'}`} />&nbsp;
                                    {t('common.yes')}
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </ModalComponent>
            )}
            {successfullyForgot && (
                <div className="alert alert-success text-lg font-normal">
                    { t(`devices.successfully_forgot_this_${device?.type}`) }
                </div>
            )}
            {failedToForget && (
                <div className="alert alert-danger text-lg font-normal">
                    { t(`devices.could_not_forget_this_${device?.type}`) }
                </div>
            )}
            <Button color="warning" disabled={device.status !== 'disconnected'}  onClick={() => showConfirm(true) }>
                <i className="fa fa-trash" />&nbsp;
                {t(`devices.forget_this_${device.type}`)}
            </Button>
        </>
    );
}

export default ForgetDeviceButton;
